"use strict";
exports.__esModule = true;
exports.getScheduleOptionsResponse = exports.pendingOfferDocumentVerification = exports.pendingOfferVerifyIncomeIncomeVerification = exports.pendingOfferIncomeVerification = exports.pendingOfferCreditBuilder = exports.pendingOfferSLC = exports.deniedOffer = exports.pendingOffer = exports.acceptedOfferFSLC = exports.acceptedOffer = exports.initiatedOffer = exports.acceptanceTime = exports.underwritingCompletionTime = exports.initiationTime = exports.hourInMillis = exports.testDebtor = exports.testOfferId = void 0;
var membershipFee = {
    amount_cent: 1499,
    schedule: 'P1M'
};
var processingFee = {
    debit_card_processing_fee_bps: 75
};
var fees = {
    membership_fee: membershipFee,
    processing_fee: processingFee,
    property_passthrough_fee_amount: 300
};
var documents = {
    cla: {
        version: '2022-06-28'
    },
    tila: {
        version: '2022-06-28'
    }
};
var installmentFSLC = {
    proportion: 100,
    repayment_due: 'P2D'
};
var firstInstallmentSLC = {
    proportion: 50,
    repayment_due: 'P14D'
};
var secondInstallmentSLC = {
    proportion: 0,
    repayment_due: 'P26D'
};
var halfInstallment = {
    proportion: 0,
    due_offset: 'P1D'
};
var endInstallment = {
    proportion: 50,
    due_offset: 'P15D'
};
exports.testOfferId = 'adfe3ee6-2f95-443e-9fc2-0cd4d2b9aa36';
exports.testDebtor = {
    date_of_birth: '1997-07-21',
    ssn: '333-33-0100'
};
exports.hourInMillis = 3600000;
exports.initiationTime = new Date(Date.now() - exports.hourInMillis).toUTCString();
exports.underwritingCompletionTime = new Date(Date.now() - exports.hourInMillis / 4).toUTCString();
exports.acceptanceTime = new Date(Date.now() - exports.hourInMillis / 3).toUTCString();
var offerFactory = function (offerState, initiatedTime, acceptedTime, underwritingTime, installments, onboardingIncomeVerificationId, evaluateCurrentStep, onboardingDocumentVerificationId) { return ({
    offer_id: exports.testOfferId,
    offer_state: offerState,
    fees: fees,
    estimated_bill_amount_cent: 130000,
    documents: documents,
    installments: installments || [halfInstallment, endInstallment],
    kyc_pass: true,
    credit_limit_pass: true,
    credit_limit_amount_cent: 50000,
    credit_utilization_cent: 50000,
    initiation_time: initiatedTime,
    acceptance_time: acceptedTime,
    underwriting_completion_time: underwritingTime,
    onboarding_income_verification_id: onboardingIncomeVerificationId,
    current_evaluate_step: evaluateCurrentStep,
    onboarding_identity_document_verification: {
        docv_checkpoint_log_id: '',
        verification_id: onboardingDocumentVerificationId ? onboardingDocumentVerificationId : '',
        resubmit: false
    }
}); };
exports.initiatedOffer = offerFactory('Initiated', exports.initiationTime, null, null);
exports.acceptedOffer = offerFactory('Accepted', exports.initiationTime, exports.acceptanceTime, exports.underwritingCompletionTime);
exports.acceptedOfferFSLC = offerFactory('Accepted', exports.initiationTime, exports.acceptanceTime, exports.underwritingCompletionTime, [
    installmentFSLC,
    secondInstallmentSLC,
]);
exports.pendingOffer = offerFactory('PendingAccept', exports.initiationTime, null, exports.underwritingCompletionTime);
exports.deniedOffer = offerFactory('Denied', exports.initiationTime, null, exports.underwritingCompletionTime);
exports.pendingOfferSLC = offerFactory('PendingAccept', exports.initiationTime, null, exports.underwritingCompletionTime, [
    firstInstallmentSLC,
    secondInstallmentSLC,
]);
exports.pendingOfferCreditBuilder = offerFactory('PendingAccept', exports.initiationTime, null, exports.underwritingCompletionTime, [installmentFSLC, secondInstallmentSLC]);
exports.pendingOfferIncomeVerification = offerFactory('PendingEvaluate', exports.initiationTime, null, exports.underwritingCompletionTime, undefined, 'verificationId', 'VerifyIncome');
exports.pendingOfferVerifyIncomeIncomeVerification = offerFactory('PendingEvaluate', exports.initiationTime, null, exports.underwritingCompletionTime, undefined, 'verificationId', 'VerifyIncome');
exports.pendingOfferDocumentVerification = offerFactory('PendingEvaluate', exports.initiationTime, null, exports.underwritingCompletionTime, undefined, undefined, 'IdentityDocumentVerification', 'documentVerificationId');
exports.getScheduleOptionsResponse = {
    simple_one_repayment_schedule: {
        earliest_repayment_day_of_month: 8,
        latest_repayment_day_of_month: 28
    },
    slc_schedule: {
        repayment_one: {
            earliest_due_simple: 'P9D',
            latest_due_simple: 'P27D',
            latest_due_next_month: '1M-1D'
        },
        repayment_two: {
            earliest_due_simple: 'P9D',
            latest_due_simple: 'P27D',
            latest_due_next_month: '1M-1D'
        }
    }
};
